import React from 'react';
import moment from 'moment';
import { Badge } from 'react-bootstrap';
import {
    getListPaymentStatus,
    hasPaymentDate,
    isHoldingTransferSuccess,
} from './reconPaymentHelpers';

const formatPaymentSuccessDate = (paymentDate) => {
    const parsed = moment(
        paymentDate,
        ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD', moment.ISO_8601],
        true
    );
    if (!parsed.isValid()) return String(paymentDate).trim();
    return parsed.format('DD-MM-YYYY');
};

/** ONLINE/OFFLINE + payment status (Success includes paid-on date when available) */
const PaymentModeStatusBadges = ({
    row,
    holdingLabel = 'Trf to holding',
    holdingBadgeStyle = {
        backgroundColor: '#e7f1ff',
        color: '#0b5ed7',
    },
}) => {
    const paymentStatus = getListPaymentStatus(row);
    const showTrfToHolding = isHoldingTransferSuccess(row);
    const paymentSuccessDate = hasPaymentDate(row?.payment_date)
        ? formatPaymentSuccessDate(row.payment_date)
        : null;
    const isSuccess = paymentStatus?.label === 'Success';

    const statusLabel =
        isSuccess && paymentSuccessDate
            ? `Success · ${paymentSuccessDate}`
            : paymentStatus?.label;

    return (
        <div className="mt-1">
            <div className="d-flex flex-wrap gap-1 align-items-center">
                <Badge bg={row?.payment_mode === 'offline' ? 'secondary' : 'primary'}>
                    {row?.payment_mode?.toUpperCase()}
                </Badge>
                {paymentStatus && (
                    <span
                        title={
                            isSuccess && paymentSuccessDate
                                ? `Beneficiary payment success on ${paymentSuccessDate}`
                                : [row.reason_code, row.reason].filter(Boolean).join(' — ') ||
                                  undefined
                        }
                        style={{
                            padding: '2px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontWeight: 600,
                            backgroundColor: paymentStatus.color,
                            color: paymentStatus.textColor,
                        }}
                    >
                        {statusLabel}
                    </span>
                )}
            </div>
            {showTrfToHolding && (
                <div className="mt-1">
                    <span
                        title="Deduction transferred to holding account"
                        style={{
                            padding: '2px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontWeight: 600,
                            ...holdingBadgeStyle,
                        }}
                    >
                        {holdingLabel}
                    </span>
                </div>
            )}
        </div>
    );
};

export default PaymentModeStatusBadges;
